import { from, of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { disconnectUserSuccess } from '../../../actions/room/room'
import { roomTypes } from '../../../actions/room/roomTypes'

const disconnect$ = (actions$, state$, { disconnectRoom }) => actions$.pipe(
  ofType(roomTypes.DISCONNECT_USER),
  mergeMap(() =>
    from(disconnectRoom(state$.value.room.room)).pipe(
      mergeMap(result =>
        result ? of(disconnectUserSuccess()) : of(null)
      )
    )
  )
)

export default disconnect$
